import { render, staticRenderFns } from "./ConsumptionDetail.vue?vue&type=template&id=2b7825ac&scoped=true"
import script from "./ConsumptionDetail.vue?vue&type=script&lang=js"
export * from "./ConsumptionDetail.vue?vue&type=script&lang=js"
import style0 from "./ConsumptionDetail.vue?vue&type=style&index=0&id=2b7825ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7825ac",
  null
  
)

export default component.exports